import gameIds from '../../hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.GEM_NYE_FRIENDS;

export const QUESTIONS_PER_LEVEL = 6;

export const MASTERY_SCORE = 5;

export const DISABLED_OPACITY = 0.2;

// match the types in the curriculums, hence the lowercase values
export const CURRICULUM_TYPES = {
  ONSETRIMES: 'onsetrimes',
  PHONEMES: 'phonemes',
  SYLLABLES: 'syllables',
  COMPOUNDS: 'compounds',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  INSTRUCTION: 'INSTRUCTION',
  PRACTICE: 'PRACTICE',
  ONBOARDING: 'ONBOARDING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  START_LEVEL: 'START_LEVEL',
  INCREMENT_PROGRESS: 'INCREMENT_PROGRESS',
  PLAY_BOTS_ANIMATION: 'PLAY_BOTS_ANIMATION',
  END_BOTS_ANIMATION: 'END_BOTS_ANIMATION',
  SET_BOTS_FRAME: 'SET_BOTS_FRAME',
  SET_ALEX_ACTIVE: 'SET_ALEX_ACTIVE',
  SET_ALEX_INACTIVE: 'SET_ALEX_INACTIVE',
  SET_ALEX_SPEAKING: 'SET_ALEX_SPEAKING',
  START_HELP: 'START_HELP',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  EXIT_ONBOARDING: 'EXIT_ONBOARDING',
  INCREMENT_SCORE: 'INCREMENT_SCORE',
  UNLOCK_LEVEL: 'UNLOCK_LEVEL',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const BOT_FRAMES = {
  IDLE: 'IDLE',
  LOOK_DOWN: 'LOOK_DOWN',
  HANDS_UP: 'HANDS_UP',
  INCORRECT_ANSWER: 'INCORRECT_ANSWER',
  MERGED: 'MERGED',
  MERGED_HANDS_UP: 'MERGED_HANDS_UP',
};

export const BOT_ANIMATIONS = {
  NONE: 'NONE',
  DEFAULT: 'DEFAULT',
  INCORRECT_ANSWER: 'INCORRECT_ANSWER',
  CORRECT_ANSWER: 'CORRECT_ANSWER',
  EASTER_EGG_PART_1: 'EASTER_EGG_PART_1',
  EASTER_EGG_PART_2: 'EASTER_EGG_PART_2',
  INSTRUCTION_PART_1: 'INSTRUCTION_PART_1',
  INSTRUCTION_PART_2: 'INSTRUCTION_PART_2',
  INSTRUCTION_PART_3: 'INSTRUCTION_PART_3',
  MERGE_BOTS: 'MERGE_BOTS',
  INSTRUCTION_MERGE: 'INSTRUCTION_MERGE',
  INSTRUCTION_END: 'INSTRUCTION_END',
  BLEND: 'BLEND',
  ELONGATED: 'ELONGATED',
  BOT_PRESSED: 'BOT_PRESSED',
  ONBOARDING_PART_1: 'ONBOARDING_PART_1',
  ONBOARDING_FULL_WORD: 'ONBOARDING_FULL_WORD',
  GEM_JUMP: 'GEM_JUMP',
  NYE_JUMP: 'NYE_JUMP',
};

export const FRIENDBOT_TYPES = ['friend1', 'friend2', 'friend3', 'friend4', 'friend5', 'friend6'];

export const SYLLABOT_TYPES = ['syllabot1', 'syllabot2', 'syllabot3', 'syllabot4'];

export const GEM_NYE_SEGMENTS = {
  [BOT_FRAMES.IDLE]: [0, 90],
  [BOT_FRAMES.INCORRECT_ANSWER]: [90, 150],
  [BOT_FRAMES.LOOK_DOWN]: [150, 210], // Selection
  [BOT_FRAMES.HANDS_UP]: [211, 271], // SFX
  [BOT_FRAMES.MERGED]: [272, 289],
  SYLLABOT_MERGED_IDLE: [0, 60],
};

export const CONTAINER_WIDTHS = {
  [CURRICULUM_TYPES.ONSETRIMES]: 500,
  [CURRICULUM_TYPES.PHONEMES]: 300,
  [CURRICULUM_TYPES.SYLLABLES]: 300,
  [CURRICULUM_TYPES.COMPOUNDS]: 500,
};

export const FOCUS_STYLES = {
  BORDER: '#100163',
  OUTLINE: '#FFF',
};

export const PROGRESS_COLORS = {
  BUTTONS: '#009FDD',
  TEXT: '#FFF',
};

// Compounds
export const BOTS_COMPOUNDS = ['gem', 'nye', 'mergedgemnye'];
export const ANIMATION_COMPOUNDS = ['gem', 'mergedgemnye'];

// Syllables
export const BOTS_SYLLABLES = ['syllabot1', 'syllabot2', 'syllabot3', 'syllabot4', 'mergedbot'];
export const ANIMATION_SYLLABLES = ['syllabot1', 'syllabot4'];
export const MERGED_ANIMATION_SYLLABLES = ['mergedSyllabots2', 'mergedSyllabots3', 'mergedSyllabots4'];

// SetRimes
export const BOTS_SETRIMES = ['onset', 'rime', 'mergedbot'];
export const ANIMATION_SETRIMES = ['onset'];
export const MERGED_ANIMATION_SETRIMES = ['mergedbot'];

// Phonemes
export const BOTS_PHONEMES = ['friend1', 'friend2', 'friend3', 'friend4', 'friend5', 'friend6'];
export const ANIMATIONS_PHONEMES = ['friend1'];
export const MERGE_ANIMATIONS_PHONEMES = ['mergedFriends2', 'mergedFriends3', 'mergedFriends4', 'mergedFriends5'];
